import { OrderDirection, OrderInput } from '@aircall/tractor-v2';
import { LineStatus } from '@generated/globalTypes';

export enum LINE_TYPE_VALUES {
  'IVR' = 'IVR',
  'CLASSIC' = 'Classic',
  'SMARTFLOW' = 'Smartflow',
  'SMS' = 'SMS',
  'MMS' = 'MMS',
}

export enum AVAILABILITY_FILTER_VALUES {
  AVAILABLE = 'Available',
  OFFLINE = 'Offline',
  PENDING_VALIDATION = 'Pending Validation',
}

export enum LIST_VIEW_PARAMS {
  TEAMS = 'teams',
  SEARCH = 'search',
  ROLES = 'roles',
  AVAILABILITY = 'availability',
  COUNTRY = 'country',
  LINE_TYPE = 'type',
  LINE_STATUS = 'status',
  SORT_DIRECTION = 'direction',
  SORT_FIELD = 'field',
}

export interface FilterTypeMapper {
  [LIST_VIEW_PARAMS.TEAMS]: string[];
  [LIST_VIEW_PARAMS.ROLES]: string[];
  [LIST_VIEW_PARAMS.AVAILABILITY]: string[];
  [LIST_VIEW_PARAMS.SEARCH]: string;
  [LIST_VIEW_PARAMS.COUNTRY]: string[];
  [LIST_VIEW_PARAMS.LINE_TYPE]: LINE_TYPE_VALUES[];
  [LIST_VIEW_PARAMS.LINE_STATUS]: LineStatus[];
  [LIST_VIEW_PARAMS.SORT_DIRECTION]: OrderDirection;
  [LIST_VIEW_PARAMS.SORT_FIELD]: OrderInput['field'];
}

export type Get = {
  <T extends LIST_VIEW_PARAMS>(filter: T): FilterTypeMapper[T] | null;
  <T extends LIST_VIEW_PARAMS>(filter: T, defaultValue: unknown): FilterTypeMapper[T];
};

export interface UseListViewFilters {
  set: (filter: LIST_VIEW_PARAMS, value: string | string[]) => void;
  setDebounced: (filter: LIST_VIEW_PARAMS, value: string | string[]) => void;
  setMultiple: <T extends LIST_VIEW_PARAMS>(
    filtersValues: Partial<Record<LIST_VIEW_PARAMS, FilterTypeMapper[T]>>
  ) => void;
  get: Get;
}
